<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="">
          <div class="title-effective">
            产品名称：
          </div>
          <div class="context">
            {{WarnInfoData.InvName}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 70px;"> 
            批号：
          </div>
          <div class="context">
            {{WarnInfoData.Batch}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            生产日期：
          </div>
          <div class="context">
            {{WarnInfoData.ValiDate}}
          </div>
        </div>
      </div>
      <!--右半部分-->
      <div class="right-effective">
        <div class="">
          <div class="title-effective">
            产品型号：
          </div>
          <div class="context">
            {{WarnInfoData.InvAddCode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 70px;">
            数量：
          </div>
          <div class="context">
            {{WarnInfoData.Quantity}}
          </div>
        </div>
      </div>
    </div>
    <div class="reject-effective">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
      <span v-html="$options.filters.filters2(WarnInfoList.StringMessage)">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    WarnInfoData: {
      type: undefined
    },
    WarnInfoList: {
      type: Object
    }
  },
   filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>